import moment from 'moment';

export default (date, time) => {
  const dateStr = moment(date).format('YYYY-MM-DD');
  const timeStr = moment(time).format('HH:mm:ss');

  return moment(`${dateStr} ${timeStr}`, 'YYYY-MM-DD HH:mm:ss');
};
